import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { generateClient } from 'aws-amplify/api';
import type { Schema } from '../../amplify/data/resource';
import Button from '@/components/ui/Button';

const client = generateClient<Schema>();

export default function InviteLanding() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') ?? '';

  const [status, setStatus] = useState<'validating' | 'valid' | 'invalid'>('validating');

  useEffect(() => {
    if (!token) { setStatus('invalid'); return; }

    client.queries
      .validateInviteToken({ token })
      .then((res) => {
        setStatus(res.data ? 'valid' : 'invalid');
      })
      .catch(() => setStatus('invalid'));
  }, [token]);

  if (status === 'validating') {
    return (
      <div className="invite-page">
        <p>Checking your invitation…</p>
      </div>
    );
  }

  if (status === 'invalid') {
    return (
      <div className="invite-page">
        <h1>Invitation Invalid</h1>
        <p>This invite link has expired or has already been used.</p>
        <p>Ask Richard to send a new invite link.</p>
      </div>
    );
  }

  return (
    <div className="invite-page">
      <div className="invite-card">
        <h1>You're invited to MySommly</h1>
        <p>Create your account to start tracking and discovering wines with the family.</p>
        <Button
          variant="primary"
          onClick={() => navigate(`/login?invite=${token}&mode=signup`)}
          fullWidth
        >
          Create my account
        </Button>
      </div>
    </div>
  );
}
